<template>
  <div class="page-content users-table-view" style="height: 100vh;">
    <div class="container-fluid bracket-custom-style">
      <Card class="header-card">
        <Row>
          <div
            :class="user && user.role[0] === 'admin' ? 'header-card-column-style' : 'd-flex justify-content-between align-items-center'">
            <Col :xs="user && user.role[0] === 'admin' ? 24 : 12" :md="user && user.role[0] === 'admin' ? 16 : 12"
              class="d-flex align-items-center mr-2">
            <span class="page-title d-none d-lg-inline">{{ $t('menu.licenses') }}</span>
            <Select class="" v-model="tableLenght" style="width: 70px" :placeholder="$t('global.kiezen')">
              <Option :value="10">10</Option>
              <Option :value="25">25</Option>
              <Option :value="50">50</Option>
              <Option :value="100">100</Option>
            </Select>
            <Select v-if="user && isAdmin" class="ml-2" v-model="filterClub" multiple style="width: 200px"
              :placeholder="$t('global.kiezen')">
              <Option v-for="club in clubs" :key="club._id" :value="club._id">{{ club.name }}</Option>
            </Select>
            <Select v-if="user && isAdmin" class="ml-2" v-model="filterSex" multiple style="width: 200px"
              :placeholder="$t('global.kiezen')">
              <Option :value="1">{{ $t('global.male') }}</Option>
              <Option :value="2">{{ $t('global.female') }}</Option>
            </Select>
            </Col>
            <Col :xs="user && user.role[0] === 'admin' ? 24 : 12" :md="user && user.role[0] === 'admin' ? 8 : 12"
              class="d-flex justify-content-end" :class="user && user.role[0] === 'admin' ? 'mb-2 mb-md-0' : ''">
            <Button class="mr-2" type="warning" @click="exportToXLS()"><b>XLS</b></Button>
            <Button type="warning" @click="modalAdd = true"><b>{{ $t('global.add') }}</b></Button>
            </Col>
          </div>
        </Row>
      </Card>
      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>
      <Row v-else class="h-100" style="margin-top: 0; overflow: hidden; border-radius: 4px;">
        <Col span="24" class="h-100">
        <div class="card mb-0 h-100">
          <div class="card-body-table h-100" style="overscroll-behavior: none;">
            <table ref="licenseTable" class="table table-bordered dt-responsive table-striped nowrap license-table">
              <thead class="positionThead">
                <tr>
                  <th v-if="!isPrint" style="width: 145px; min-width: 145px">
                    <Button v-if="checked.length" @click="openMultiPreview()" size="small" type="primary">
                      Print
                    </Button>
                    <Button v-if="checked.length && isAdmin" @click="deleteLicenses()" size="small" type="error">
                      Delete
                    </Button>
                  </th>
                  <TableaHeadCol column="firstNameSearch" :title="$t('user.table.name')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <TableaHeadCol column="secondNameSearch" :title="$t('user.table.surname')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <TableaHeadCol column="clubSearch" :title="$t('club.club')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <TableaHeadCol column="birthday" :title="$t('club.form.birthday')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <TableaHeadCol column="bdaySearch" :title="$t('global.category')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <TableaHeadCol column="sexSearch" :title="$t('club.table.sex')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <TableaHeadCol column="townSearch" :title="$t('labels.city')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <!-- <TableaHeadCol style="width: 125px; min-width: 125px" column="nationality" :title="$t('user.form.nationality')" /> -->
                  <TableaHeadCol column="photo" :title="$t('club.table.photo')" />
                  <TableaHeadCol column="membership" :title="$t('club.table.contract')" />
                  <TableaHeadCol column="passportId" :title="$t('club.table.passport')" />
                  <TableaHeadCol column="displayMedicalDate" :title="$t('club.table.control')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />
                  <TableaHeadCol column="displayNotes" :title="$t('driver.description')" :sortColumn="sortColumn"
                    :sortByValue="sortByValue" @sortBy="ColHead" />

                </tr>
                <tr v-if="!isPrint">
                  <th>
                    <Input v-model="search.id" :placeholder="$t('global.search')" clearable />
                  </th>
                  <th>
                    <Input v-model="search.firstNameSearch" :placeholder="$t('global.search')" clearable />
                  </th>
                  <th>
                    <Input v-model="search.secondNameSearch" :placeholder="$t('global.search')" clearable />
                  </th>
                  <th>
                    <Input v-model="search.clubSearch" :placeholder="$t('global.search')" clearable />
                  </th>
                  <th></th>
                  <th>
                    <Input v-model="search.categorySearch" :placeholder="$t('global.search')" clearable />
                  </th>
                  <th></th>
                  <th>
                    <Input v-model="search.townSearch" :placeholder="$t('global.search')" clearable />
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>
                    <Input v-model="search.displayNotes" :placeholder="$t('global.search')" clearable />
                  </th>
                </tr>
              </thead>
              <tbody v-if="arrayList.data.length">
                <template v-for="(item) in arrayList.data">
                  <tr :key="item._id">
                    <td v-if="!isPrint" style="vertical-align: middle; position: relative;">
                      <div class="text-center d-flex pl-2">
                        <input type="checkbox" class="edit-checkbox group mr-2" v-model="checked" :value="item._id">
                        <Button v-if="!isPrint" :disabled="item.isNotApproved" @click="openPreview(item)" type="dashed"
                          :class="{ 'user-info-btn mr-2': true, 'user-active': item.status === 2, 'user-blocked': item.status === 0 }"
                          icon="md-eye">
                        </Button>
                        <Button @click="() => { selected = item; modalAdd = true; }" type="dashed"
                          :class="{ 'user-info-btn': true, 'user-active': item.status === 2, 'user-blocked': item.status === 0 }">
                          {{ item.id }}
                        </Button>
                        <Icon v-if="item.isNotApproved" type="md-alert" color="red" class="alert-expire-date" />
                      </div>
                    </td>
                    <td>
                      <Tooltip :content="item.firstNameSearch" placement="top-start" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.firstNameSearch }}
                        </span>
                      </Tooltip>
                    </td>
                    <td>
                      <Tooltip :content="item.secondNameSearch" placement="top-start" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.secondNameSearch }}
                        </span>
                      </Tooltip>
                    </td>
                    <td>
                      <Tooltip :content="item.clubId ? item.clubId.name : ''" placement="top-start" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.clubId ? item.clubId.name : '' }}
                        </span>
                      </Tooltip>
                    </td>
                    <td>
                      <Tooltip :content="item.bdaySearch | moment('DD.MM.YYYY')" placement="top-start" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.bdaySearch | moment("DD.MM.YYYY") }}
                        </span>
                      </Tooltip>
                    </td>
                    <td>
                      <!-- <Tooltip
                        v-if="(item.categoryId && item.categoryId.name === 'SPORTSMAN') || (item.newcategoryId && item.newcategoryId.name === 'SPORTSMAN')"
                        :content="item.displayAge"
                        placement="top-start" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.displayAge }}
                        </span>
                      </Tooltip> -->

                      <Tooltip :content="item.categorySearch" placement="top-start" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.categorySearch }}
                        </span>
                      </Tooltip>
                    </td>
                    <td>
                      <Tooltip :content="item.displaySex" placement="top-start" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.displayShortSex }}
                        </span>
                      </Tooltip>
                    </td>
                    <td>
                      <Tooltip :content="item.townSearch" placement="top-start" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.townSearch }}
                        </span>
                      </Tooltip>
                    </td>
                    <!-- <td>
                      <Tooltip :content="item.newnationality ? item.newnationality : item.nationality" placement="top-start" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.newnationality ? item.newnationality : item.nationality }}
                        </span>
                      </Tooltip>
                    </td> -->
                    <td>
                      <a v-for="photo in item.displayPhoto" :key="photo" :href="api_domain + photo" target="_blank">
                        <Icon v-if="!isPrint" color="#2d8cf0" custom="bx bxs-file-pdf" size="22" type="primary"></Icon>
                        <span v-else>
                          {{ api_domain + photo }}
                        </span>
                      </a>
                    </td>
                    <td>
                      <a v-for="membership in item.displayMembership" :key="membership" :href="api_domain + membership"
                        target="_blank">
                        <Icon v-if="!isPrint" color="#2d8cf0" custom="bx bxs-file-pdf" size="22" type="primary"></Icon>
                        <span v-else>
                          {{ api_domain + membership }}
                        </span>
                      </a>
                    </td>
                    <td>
                      <a v-for="passportId in item.displayPassportId" :key="passportId" :href="api_domain + passportId"
                        target="_blank">
                        <Icon v-if="!isPrint" color="#2d8cf0" custom="bx bxs-file-pdf" size="22" type="primary"></Icon>
                        <span v-else>
                          {{ api_domain + passportId }}
                        </span>
                      </a>
                    </td>
                    <td :class="{ 'medical-expired': item.expired }">
                      {{ item.displayMedicalDate }}
                      <a v-for="medical in item.displayMedical" :href="api_domain + medical" :key="medical"
                        target="_blank">
                        <Icon v-if="!isPrint" color="#2d8cf0" custom="bx bxs-file-pdf" size="22" type="primary"></Icon>
                        <span v-else>
                          {{ api_domain + medical }}
                        </span>
                      </a>
                    </td>
                    <td>
                      <Tooltip :content="item.displayNotes" placement="top-end" class="w-100">
                        <span class="text-overflow-style" v-if="!isPrint">
                          {{ item.displayNotes }}
                        </span>
                      </Tooltip>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        </Col>
      </Row>
      <Card>
        <div class="competition-footer-card">
          <div>
            <span v-if="arrayFiltered.length">
              {{ $t('global.entries') }} {{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }}
              {{
                $t('global.of') }}
              {{ arrayFiltered.length }} {{ $t('global.entry') }} ({{ $t('global.filtered', { len: array.length }) }})
            </span>
            <span v-else>
              {{ $t('global.entries') }} {{ getPageLabel(arrayList.total, parseInt(tableLenght), arrayList.page - 1) }}
              {{
                $t('global.of') }} {{ array.length }}
              {{ $t('global.entry') }}
            </span>
          </div>
          <Page @on-change="changePage" v-if="arrayList.total > 0" :current="arrayList.page"
            :page-size="parseInt(tableLenght)" :total="arrayList.total" />
        </div>
      </Card>
    </div>
    <LicenseAddModal v-if="modalAdd" :loading="loading" :license="selected" @updateList="() => { getList(); }"
      @close="() => { this.selected = null; this.modalAdd = false }" />
  </div>
</template>

<script>
import LicenseAddModal from './LicenseAddModal.vue'
import mixin from '../mixinTable'
import TableaHeadCol from '../helper/table/TableaHeadCol'
export default {
  components: {
    LicenseAddModal,
    TableaHeadCol
  },
  mixins: [mixin],
  data() {
    return {
      isPrint: false,
      modalAdd: false,
      selected: null,
      checked: [],
      clubs: [],
      filterClub: [],
      filterSex: [],
      loading: false,
      user: null,
      isAdmin: false,
    }
  },
  watch: {
    async filterClub(n, o) {
      await this.getList()
      // await this.getTempList()
    },
    async filterSex(n, o) {
      await this.getList()
      // await this.getTempList()
    },
    async tableLenght(n, o) {
      await this.getList()
      localStorage.setItem('dt.length', n)
      // await this.getTempList()
    }
  },
  methods: {
    disableFor(arr) {
      if (!this.user.role) return false;
      this.isAdmin = !arr.includes(this.user.role[0])
    },
    enableFor(arr) {
      console.log("this.$user.role", this.user.role)
      if (!this.user.role) return false;
      this.isAdmin = arr.includes(this.user.role[0])
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    openPreview(item) {
      window.open(this.api_domain + 'license/preview/' + item._id, '_blank')
    },
    async openMultiPreview() {
      try {
        const queryString = `arr=${this.checked.join(',')}`;
        const url = `${this.api_domain}license/multipreview?${queryString}`;
        window.open(url, '_blank');
      } catch (error) {
        console.log(error);
      }
    },
    async deleteLicenses() {
      // try {
      //   const queryString = `arr=${this.checked.join(',')}`;
      //   const url = `${this.api_domain}license/multipreview?${queryString}`;
      //   window.open(url, '_blank');
      // } catch (error) {
      //   console.log(error);
      // }
      this.$dialog
        .confirm(this.$t("global.confirmDelete"), {
          okText: this.$t("global.yes"),
          cancelText: this.$t("global.no"),
          //reverse: true,
        })
        .then(async (dialog) => {
          let response = await this.$http.post("/license/delete", { ids: this.checked });
          location.reload();
        })
        .catch(function () {
          console.log("Clicked on cancel");
        });
      console.log("license");
    },
    ageDetector(year) {
      let string = ''
      let d = new Date(year)
      let diff = new Date().getFullYear() - d.getFullYear()
      if (diff >= 6 && diff <= 8) {
        string = 'U-8'
      } else if (diff >= 9 && diff <= 10) {
        string = 'U-10'
      } else if (diff >= 11 && diff <= 12) {
        string = 'U-12'
      } else if (diff >= 13 && diff <= 14) {
        string = 'U-14'
      } else if (diff >= 15 && diff <= 16) {
        string = 'U-16'
      } else if (diff >= 17 && diff <= 18) {
        string = 'U-18'
      } else if (diff >= 19) {
        string = 'Senior'
      }
      return string
    },
    getSex(sex) {
      return sex === 1 ? this.$t('global.male') : sex === 2 ? this.$t('global.female') : null
    },
    ColHead(val) {
      this.sortColumn = val
      this.sortBy()
    },
    getCurrentUser() {
      const user = localStorage.getItem('user')
      this.user = JSON.parse(user)
    },
    generateData(data) {
      this.loading = true
      data.forEach(item => {
        let cat = item.categoryId && item.categoryId.name === 'SPORTSMAN' ? this.ageDetector(item.birthday) : item.categoryId && item.categoryId.name
        let newcat = item.newcategoryId && item.newcategoryId.name === 'SPORTSMAN' ? this.ageDetector(item.newbirthday) : item.newcategoryId && item.newcategoryId.name
        item.expired = false
        if (item.medical_Date) {
          if (parseInt(item.medical_Date) < new Date().getFullYear()) { item.expired = true }
        }
        item.clubSearch = item.clubId ? item.clubId.name : ''
        item.categorySearch = item.newcategoryId ? newcat : cat
        item.sexSearch = item.newsex ? item.newsex : item.sex
        item.firstNameSearch = item.newfirstName ? item.newfirstName : item.firstName
        item.secondNameSearch = item.newsecondName ? item.newsecondName : item.secondName
        item.bdaySearch = item.newbirthday ? item.newbirthday : item.birthday
        item.townSearch = item.newtown ? item.newtown : item.town
        item.displaySex = this.getSex(item.newsex ? item.newsex : item.sex)
        item.displayShortSex = this.getSex(item.newsex ? item.newsex : item.sex) && this.getSex(item.newsex ? item.newsex : item.sex).charAt(0)
        item.isNotApproved = this.checkIfChanged(item)
        item.displayPhoto = item.newphoto && item.newphoto.length ? item.newphoto : item.photo
        item.displayMembership = item.newmembership && item.newmembership.length ? item.newmembership : item.membership
        item.displayPassportId = item.newpassportId && item.newpassportId.length ? item.newpassportId : item.passportId
        item.displayMedical = item.newmedical && item.newmedical.length ? item.newmedical : item.medical
        item.displayMedicalDate = item.newmedical_Date ? item.newmedical_Date : item.medical_Date
        let temp = item.newnotes ? item.newnotes : item.notes
        item.displayNotes = temp || ""
      })
      this.loading = false

      return data
    },
    checkIfChanged(item) {
      let fields = Object.keys(item)
      let flag = false
      for (let i = 0; i < fields.length; i++) {
        const element = fields[i];
        if (element.substring(0, 3) === 'new') {
          flag = true
        }
      }
      return flag
    },
    async getList() {
      let form = {}
      if (this.filterClub.length) {
        form['club'] = this.filterClub
      }
      if (this.filterSex.length) {
        form['sex'] = this.filterSex
      }
      let response
      if (this.user.role.includes('manager')) { response = await this.$http.post('/license/list', { ...form, club: this.user.clubId }) }
      else
        response = await this.$http.post('/license/list', form)
      // let list = response.data
      let list = await this.getTempList(response.data)
      let interArray = this.generateData(list.sort((a, b) => this.checkIfChanged(a) ? -1 : this.checkIfChanged(b) ? 1 : 0))
      this.array = [...interArray]
      this.arrayList = this.paginator(this.array, 1, this.tableLenght)
      this.applySearch(this.search);
      this.sortTable()
    },
    async getTempList(arr) {
      let form = {}
      if (this.filterClub.length) {
        form['club'] = this.filterClub
      }
      if (this.filterSex.length) {
        form['sex'] = this.filterSex
      }
      let response
      if (this.user.role.includes('manager')) { response = await this.$http.post('/temp-license/list', { ...form, club: this.user.clubId }) }
      else
        response = await this.$http.post('/temp-license/list', form)
      let list = response.data
      list.forEach((el) => {
        let index = arr.findIndex((item) => item._id === el._id)
        let fields = arr[index] ? Object.keys(arr[index]) : []
        if (fields.length)
          for (let i = 0; i < fields.length; i++) {
            const element = fields[i];
            if (typeof element !== 'undefined') {
              if (arr[index].hasOwnProperty(element) && typeof el[element] !== 'object' && arr[index][element] !== el[element]) {
                arr[index]['new' + element] = el[element]
              }
              else if (arr[index].hasOwnProperty(element) && typeof el[element] === 'object' && !el[element]) {
                arr[index]['new' + element] = el[element]
              }
              else if (arr[index].hasOwnProperty(element) && typeof el[element] === 'object' && !el[element].hasOwnProperty('length') && !arr[index][element]) {
                arr[index]['new' + element] = el[element]
              }
              else if (arr[index].hasOwnProperty(element) && typeof el[element] === 'object' && !el[element].hasOwnProperty('length') && arr[index][element]._id !== el[element]._id) {
                arr[index]['new' + element] = el[element]
              }
              else if (arr[index].hasOwnProperty(element) && typeof el[element] === 'object' && el[element].hasOwnProperty('length') && arr[index][element].toString() !== el[element].toString()) {
                arr[index]['new' + element] = el[element]
              }
            }
          }
      }
      )
      return arr
    },
    async getClubs() {
      let response = await this.$http.post('/club/list', {})
      let list = response.data
      this.clubs = [...list]
    },
    async exportToXLS() {
      this.isPrint = true
      let temp = this.arrayList
      let arraytemp = (this.arrayFiltered.length ? [...this.arrayFiltered] : [...this.array])

      if (this.checked.length) {
        arraytemp = arraytemp.filter(item => this.checked.includes(item._id.toString()))
      }
      this.arrayList = this.paginator(arraytemp, 1, arraytemp.length)
      console.log(arraytemp, this.arrayList)
      // eslint-disable-next-line no-undef
      $('#licenseTable').css({
        'contain': 'strict'
      })
      await this.$nextTick();
      if (this.$refs.licenseTable) {
        console.log(this.$refs.licenseTable)
        let workbook = window.XLSX.utils.table_to_book(this.$refs.licenseTable);
        let ws = workbook.Sheets['Sheet1'];
        window.XLSX.utils.sheet_add_aoa(ws, [['Created ' + `${this.$moment(new Date()).format('DD.MM.YYYY, hh:mm')}`]], { origin: -1 });
        window.XLSX.writeFile(workbook, 'license.xlsx');
      } else {
        console.error("Table element is null or undefined");
      }
      this.arrayList = temp
      this.isPrint = false
      // eslint-disable-next-line no-undef
      $('#licenseTable').css({
        'contain': 'unset'
      })
    },
  },
  async mounted() {
    this.loading = true
    this.tableLenght = +this.tableLenght;
    this.getCurrentUser()
    this.enableFor(['super', 'admin', 'license_admin'])
    // this.disableFor(['admin'])
    await this.getList()
    // await this.getTempList()
    await this.getClubs()
    this.loading = false
  }
}
</script>

<style scoped>
.positionThead tr th {
  outline: 1px solid #f8f9fa;
  outline-offset: -1px;
}

#users-table {
  border-collapse: inherit;
  border-spacing: 0;
  width: inherit;
  contain: unset;
  table-layout: fixed;
  margin: 0 auto;
}

.bracket-custom-style .ivu-spin {
  background: #454751 !important;
  color: #ffffff;
}

.users-table-view .header-card {
  background: var(--bg-darkness);
  color: var(--text-color);
}

.users-table-view .page-title {
  font-size: 24px;
  font-weight: 600;
}

.users-table-view .table-striped tbody tr:nth-of-type(odd) {
  background-color: #e8e8e8;
}

.users-table-view :global(.ivu-select-selection .ivu-select-placeholder) {
  color: #495057;
}

.users-table-view .table tbody tr:hover,
.users-table-view .table-striped tbody tr:nth-of-type(odd):hover {
  background: #d3d3d3;
}

.users-table-view .card-body-table {
  overflow-x: scroll;
  /* height: calc(100vh - 275px); */
  height: calc(100% - 220px);
  /* height: calc(100vh - 50px); */
  padding: 0;
}

.card-body-table .expire {
  background: #FCC9C5;
}

.card-body-table .todayBirthday {
  background: #8fbc8f75;
}

.card-body-table .tomorrowBirthday {
  background: #ffff0042;
}

#users-table :global(.ivu-tooltip-rel) {
  cursor: pointer;
}

/*.sort-by {*/
/*  display: inline-block;*/
/*  float: right;*/
/*  cursor: pointer;*/
/*}*/

.user-info-btn {
  padding: 0 10px;
  line-height: 1;
}

.user-active {
  color: green;
}

.user-blocked {
  color: red;
}

.medical-expired {
  background: #FCC9C5;
}

#users-table td.user-style :global(.ivu-tooltip-rel) {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  vertical-align: middle;
}

#users-table td.user-style :global(.ivu-tooltip) {
  width: 205px;
}

#users-table td.user-iban-style :global(.ivu-tooltip) {
  width: 180px;
}

#users-table tr td {
  font-size: 14px !important;
  line-height: 15px;
}

#users-table tr td,
#users-table tr th {
  vertical-align: middle;
  padding: 7px 5px;
  position: relative;
}

#users-table td.user-phone-list :global(.ivu-tooltip-rel) {
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  max-height: 32px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

#users-table td.user-phone-list :global(.ivu-tooltip) {
  width: 129px;
}

.badge-soft-primary {
  background-color: #dbe1f7 !important;
}

.good-rating {
  color: #18BE6B;
}

.average-rating {
  color: #FF9A01;
}

.black-list-rating {
  color: #EE4014;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before) {
  color: #18BE6B;
}

.md-checkmark-style :global(.ivu-icon-md-checkmark-circle:before),
.md-checkmark-style :global(.ivu-icon-md-checkmark-circle-outline:before) {
  line-height: 1;
  font-size: 16px;
}

.header-card-column-style {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main-content .page-content .bracket-custom-style {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
}

.competition-footer-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media only screen and (max-width: 1199.98px) {

  .license-table th,
  .license-table td {
    padding: 4px;
    font-size: 13px;
    min-width: 120px;
    width: 120px;
  }
}

@media only screen and (max-width: 767.98px) {
  .header-card-column-style {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .header-card-column-style :global(.ivu-select-multiple .ivu-select-selection) {
    padding: 0 4px 0 4px !important;
  }

  .competition-footer-card {
    text-align: center;
    flex-direction: column;
    gap: 15px;
  }

  .main-content .page-content .bracket-custom-style {
    gap: 15px;
    padding-bottom: 50px;
  }
}

.license-table {
  table-layout: fixed;
}

.license-table .text-overflow-style {
  padding: 0;
  width: 100%;
}

.license-table .alert-expire-date {
  position: absolute;
  top: 0;
  right: 0;
}

.license-table td {
  vertical-align: middle;
}

.license-table th {
  hyphens: auto;
}

.license-table th,
.license-table td {
  padding: 4px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/license/LicenseList.vue